import React from "react";
import { Container, Text, withStyles } from "components/common";
// SET SPENDING POWER TO LOCKED
// import formatCurrency from "utils/formatCurrency";
// SET SPENDING POWER TO LOCKED END

const AvailableCredit = (
  // SET SPENDING POWER TO LOCKED
  /* { creditAvailable, locked } */
  // SET SPENDING POWER TO LOCKED END
) => (
  <div className="w-full h-full">
    <Container className="w-full flex-1 h-full justify-center">
      <div className="flex flex-col items-center text-center">
        <Text title>Spending Power</Text>
        {/* SET SPENDING POWER TO LOCKED */}
        <Text className="text-2xl md:text-3xl mt-2 text-red-500">LOCKED</Text>
        {/* {locked ? (
          <Text className="text-2xl md:text-3xl mt-2 text-red-500">
            LOCKED
          </Text>
        ) : (
          <Text className="text-2xl md:text-3xl mt-2" weight="light">
            {creditAvailable
              ? `${formatCurrency(creditAvailable.toFixed(2))}`
              : "$0"}
          </Text>
        )} */}
        {/* SET SPENDING POWER TO LOCKED END */}
      </div>
    </Container>
  </div>
);

export default withStyles(AvailableCredit);
